import React, { createContext, useState, useContext, useEffect } from 'react';

const FavoriteContext = createContext();

const STORAGE_KEY = 'emperc_favorites';

// Carregar favoritos do localStorage
const loadFavoritesFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Erro ao carregar favoritos do localStorage:', error);
    return [];
  }
};

// Salvar favoritos no localStorage
const saveFavoritesToStorage = (favorites) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch (error) {
    console.error('Erro ao salvar favoritos no localStorage:', error);
  }
};

export const FavoriteProvider = ({ children }) => {
    const [favoriteItems, setFavoriteItems] = useState(() => loadFavoritesFromStorage());

    // Sincronizar com localStorage sempre que favoritos mudarem
    useEffect(() => {
        saveFavoritesToStorage(favoriteItems);
    }, [favoriteItems]);

    const addItemToFavorites = (item) => {
        setFavoriteItems((prevItems) => {
            // Verificar se já existe (por id ou _id)
            const exists = prevItems.find(i => 
                i.id === item.id || 
                i._id === item._id || 
                (item.id && i._id === item.id) ||
                (item._id && i.id === item._id)
            );
            
            if (exists) {
                return prevItems; // Já está nos favoritos
            }
            
            // Normalizar item (garantir que tenha id e _id)
            const normalizedItem = {
                ...item,
                id: item.id || item._id,
                _id: item._id || item.id,
                addedAt: new Date().toISOString()
            };
            
            return [...prevItems, normalizedItem];
        });
    };

    const removeItemFromFavorites = (itemId) => {
        setFavoriteItems((prevItems) => 
            prevItems.filter(item => 
                item.id !== itemId && 
                item._id !== itemId
            )
        );
    };

    const isFavorite = (itemId) => {
        return favoriteItems.some(item => 
            item.id === itemId || 
            item._id === itemId
        );
    };

    const toggleFavorite = (item) => {
        const itemId = item.id || item._id;
        if (isFavorite(itemId)) {
            removeItemFromFavorites(itemId);
        } else {
            addItemToFavorites(item);
        }
    };

    const clearFavorites = () => {
        setFavoriteItems([]);
    };

    return (
        <FavoriteContext.Provider value={{ 
            favoriteItems, 
            addItemToFavorites, 
            removeItemFromFavorites,
            isFavorite,
            toggleFavorite,
            clearFavorites,
            favoritesCount: favoriteItems.length
        }}>
            {children}
        </FavoriteContext.Provider>
    );
};

export const useFavorites = () => useContext(FavoriteContext);
export default FavoriteProvider;
